<script>
import DaylogService from "@/services/DaylogService";
import dayjs from "dayjs";
import VMeta from "@/views/Daylogs/components/VMeta.vue";

export default {
    props: {
        selectedDate: {}
    },
    components: { VMeta },
    data() {
        return {
            loading: true,
            mdata: {},
            meta: {}
        };
    },
    computed: {
        day() {
            if (this.loading) {
                return null;
            }

            return this.mdata[this.selectedDate]["daylog"];
        },
        total_absence() {
            return (
                parseInt(this.day.absence_sick_time) +
                parseInt(this.day.absence_others) +
                parseInt(this.day.absence_holiday_time)
            );
        },
        total_time() {
            const sum =
                (this.day.work_time === null
                    ? 0
                    : parseInt(this.day.work_time)) + this.total_absence;
            return sum;
        },
        balance() {
            return this.total_time - this.day.goal_time;
        }
    },
    async created() {
        await this.fetchData();
        this.loading = false;
    },
    methods: {
        async fetchData() {
            try {
                const ds = dayjs(this.selectedDate);
                const { data } = await DaylogService.GET_myData(
                    ds.format("YYYY"),
                    ds.format("M")
                );
                this.mdata = data.data;
                this.meta = data.meta;
            } catch (e) {
                console.log("fd e", e);
            }
        }
    }
};
</script>

<template>
    <div>
        <v-loader :loading="loading" v-if="loading" />
        <v-meta :meta="meta" :do-px="false" v-else />
    </div>
</template>

<style lang="scss">
.v-clock-in-dash {
    margin-top: 25px;
    padding-top: 15px;
    border-top: 2px dashed $gray-400;

    h4 {
        padding-bottom: 10px;
        font-size: 12px;
        color: $gray-700;
    }
}
</style>
